<form (ngSubmit)="updateEvent()">
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" [class.modal-advTrigger]="!embedded">
  <!-- <div class="modal-content modal-advTrigger"> -->
    <div *ngIf="!embedded" style="background-color: #548235;  height: 7px;"></div>
    <div *ngIf="!embedded" class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Events and Actions '{{eventTitle}}'</h5>
      <button
        (click)="bsModalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body" (ngSubmit)="updateEvent()">

      <div class="container-fluid" style="font-size: 15px; padding: 0px;">

        <table style="width: 100%;">
          <tr>
            <td style="width:435px" align="left">
              <div class="form-group" style="margin-bottom: 20px;">
                <label for="triggerName" style="font-weight: 500;">Name*</label>
                <input [(ngModel)]="event.name" class="form-control" id="triggerName" name="triggerName"
                       [style.color]="!duplicateName ? 'black' : 'red' " (ngModelChange)="duplicateNamecheck(event.name)"
                       required type="text">
              </div>
            </td>

            <td style="width:20px"></td>

            <td style="width:125px">
              <div class="form-group">
                <label for="EvaluateStart" style="font-weight: 500;">Evaluate: &nbsp;&nbsp; From</label>
                <ngx-select-dropdown style="height: 38px;" name="EvaluateStart" [config]="EvaluateTimeGroupConfig" [options]="evaluateTimes" [(ngModel)]="event.evaluateStartTime"></ngx-select-dropdown>
              </div>
            </td>
            <td style="width:5px"></td>
            <td style="width:125px">
              <div class="form-group">
                <label for="EvaluateEnd" style="font-weight: 500;"> - To</label>
                <ngx-select-dropdown name="EvaluateEnd" [config]="EvaluateTimeGroupConfig" [options]="evaluateTimes" [(ngModel)]="event.evaluateEndTime"></ngx-select-dropdown>
              </div>
            </td>
            <td style="width:5px"></td>
            <td style="vertical-align: middle; padding-bottom: 0px;">
              <div class="weekDays-selector" style="margin-top: 5px;">
                <input type="checkbox" id="weekday-sun" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[0]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-sun">S</label>
                <input type="checkbox" id="weekday-mon" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[1]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-mon">M</label>
                <input type="checkbox" id="weekday-tue" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[2]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-tue">T</label>
                <input type="checkbox" id="weekday-wed" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[3]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-wed">W</label>
                <input type="checkbox" id="weekday-thu" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[4]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-thu">T</label>
                <input type="checkbox" id="weekday-fri" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[5]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-fri">F</label>
                <input type="checkbox" id="weekday-sat" class="weekday" [(ngModel)]="event.evaluateDaysOfWeek[6]" [ngModelOptions]="{standalone: true}" />
                <label for="weekday-sat">S</label>
              </div>
            </td>

            <td style="width:40px"></td>

            <td style="width:80px" align="center">
              <div class="form-group">
                <label for="description" style="margin-bottom: 10px; font-weight: 500;">Enabled</label>
                <p-toggleswitch id="enabled" [ngModel]="!event.isDisabled" (ngModelChange)="event.isDisabled = !$event" [ngModelOptions]="{standalone: true}" (onChange)="onEventEnable($event)" required>
                </p-toggleswitch>
              </div>
            </td>
          </tr>
        </table>

        <table style="width: 100%;">
          <tr>
            <td style="width:465px">
              <div class="form-group" style="margin-bottom: 20px;">
                <label for="description" style="font-weight: 500;">Description*</label>
                <input type="text" id="description" name="description" class="form-control" [(ngModel)]="event.description" required>
              </div>
            </td>

            <td style="width:20px"></td>

            <td style="width:435px">
              <div class="form-group">
                <label for="UserGroup" style="font-weight: 500;">Access Group*</label>
                <ngx-select-dropdown name="userGroupSelection" [config]="userGroupconfig" [options]="associatedUserGroups" [(ngModel)]="selectedUserGroup"></ngx-select-dropdown>
              </div>
            </td>

        </table>
        <br>

        <div id="accordion">
          <div class="card">
            <div style="background-color: #203864; color: white; font-size: 17px; padding-left: 10px; padding-top: 3px; height: 30px;">
              Event Conditions
            </div>
            <div id="collapseEvent" class="collapse show" aria-labelledby="EventInfo" data-parent="#accordion">
              <div class="card-body">
                <div style="font-size: 16px; margin-top: 10px;">
                  <input type="radio" [(ngModel)]="event.eventType" name="eventType" value="Sensor Based" style="accent-color: #203864;" />
                  <label style="padding-left: 5px; padding-right: 5px;">Sensor Based </label>
                    <label style="padding-left: 5px; padding-right: 10px; font-size: 14px;">[ using: </label>
                    <input type="radio" [(ngModel)]="event.eventTypeSelect" name="sensorbased" value="SensorValues" style="accent-color: #548235; transform: scale(0.85);" (ngModelChange)="setSensorBasedEventMode('SensorValues')" />
                    <label style="padding-left: 5px; padding-right: 10px; font-size: 14px;" class="css-tooltip" [attr.tooltip-data]="displayToolTipFor('lastXValues')">Values</label>
                    <input type="radio" [(ngModel)]="event.eventTypeSelect" name="sensorbased" value="SensorMinutes" style="accent-color: #548235; transform: scale(0.85);" (ngModelChange)="setSensorBasedEventMode('SensorMinutes')" />
                    <label style="padding-left: 5px; padding-right: 40px; font-size: 14px;" class="css-tooltip" [attr.tooltip-data]="displayToolTipFor('lastXMinutes')">Time ]</label>

                  <input type="radio" [(ngModel)]="event.eventType" name="eventType" value="Timer Based" style="accent-color: #203864;" />
                  <label style="padding-left: 5px; padding-right: 40px;">Timer Based</label>

                  <input type="radio" [(ngModel)]="event.eventType" name="eventType" value="Motion Based" style="accent-color: #203864;" />
                  <label style="padding-left: 5px; padding-right: 40px;">Motion Based</label>
                </div>
                <br>


                <div *ngIf="event.eventType=='Motion Based'">
                  <table style="width: 100%;">
                    <tr *ngFor="let motionCondition of event.motionConditions; let i = index; let firstel = first; let lastel = last ">

                      <td style="width:250px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'CameraDevice' + i}}" style="font-weight: 500;">Gateway</label>
                          <ngx-select-dropdown name="{{'CameraDevice' + i}}" [config]="NoSearchDDConfig" [options]="CamGatewayDDOptions" [(ngModel)]="motionCondition.deviceName" (change)="updateCameraGatewaySerial()"></ngx-select-dropdown>
                        </div>
                      </td>
  
                      <td style="width:200px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'detectionArea' + i}}" style="font-weight: 500;">Detection Area</label>
                          <ngx-select-dropdown name="{{'detectionArea' + i}}" [config]="SearchDDConfig" [options]="MotionDetectionAreaOptions" [(ngModel)]="motionCondition.detectionArea" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:100px" align="left">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'Sensitivity' + i}}" style="font-weight: 500;">Sensitivity</label>
                          <input [(ngModel)]="motionCondition.sensitivity" class="form-control" id="{{'Sensitivity' + i}}" name="{{'Sensitivity' + i}}" required type="number" style="height: 35px" (ngModelChange)="motionSensitivityCheck(motionCondition)">
                        </div>
                      </td>

                      <td style="width:150px" align="left">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'SleepAfterDetect' + i}}" style="font-weight: 500;">Sleep After Detection (sec)</label>
                          <input [(ngModel)]="motionCondition.postMotionSleepTime" class="form-control" id="{{'SleepAfterDetect' + i}}" name="{{'SleepAfterDetect' + i}}" required type="number" style="height: 35px"  (ngModelChange)="motionSleepAfterCheck(motionCondition)">
                        </div>
                      </td>

                      <td style="width:15px"></td>

                      <td style="width: 60px; color: #5279bc" class="modifications">
                        <label *ngIf="i==0" for="{{'AddMotionCondition' + i}}"><br></label>
                        <div *ngIf="!lastel" class="text-left">
                          <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delMotionCondition(i) "></div>
                        </div>
                        <div *ngIf="lastel" class="text-left">
                          <span class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delMotionCondition(i) "></span>
                          <!-- <span class="fas fa-plus pull-right" style="font-size: 18px; margin-top: 1px" aria-hidden="true " (click)="addMotionCondition()"></span> -->
                        </div>
                      </td>

                    </tr>

                    <tr *ngIf="event.motionConditions.length==0">
                      <td style="width:30px; color: #5279bc" class="modifications">
                        <div class="fas fa-plus" aria-hidden="true " (click)="addMotionCondition()"></div>
                        <span class="sr-only">Plus</span>
                      </td>
                    </tr>

                  </table>
                </div>


                <div *ngIf="event.eventType=='Sensor Based'">
                  <table style="width: 100%;">
                    <tr *ngFor="let sensorCondition of event.sensorConditions; let i = index; let firstel = first; let lastel = last">
                      <td style="width:300px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'SensorGroupDD' + i}}" style="font-weight: 500;">Sensor Group</label>
                          <ngx-select-dropdown name="{{'SensorGroupDD' + i}}" [config]="SearchDDConfig" [options]="sensorGroups" [(ngModel)]="sensorCondition.sensorGroup" (change)="sensorGroupSelectionChanged(sensorCondition.sensorGroup, sensorCondition)"></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:250px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'DateTypeDD' + i}}" style="font-weight: 500;">Reading Type</label>
                          <ngx-select-dropdown name="{{'DateTypeDD' + i}}" [config]="DataTypesDDConfig" [options]="sensorDataTypes" [(ngModel)]="sensorCondition.sensorReadingType" (open)="openSensorDataTypesDropDown(sensorCondition.sensorGroup)"></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:70px" align="left">
                        <div *ngIf="event.eventTypeSelect == 'SensorMinutes'" style="cursor: pointer;">
                          <label *ngIf="i==0" for="{{'lastXMinutes' + i}}" class="form-group" style="font-weight: 500;" >#Mins</label>
                          <input [(ngModel)]="sensorCondition.lastXMinutes" class="form-control" id="{{'lastXMinutes' + i}}" name="{{'lastXMinutes' + i}}" required type="number" style="height: 35px; padding-top: 0px;">
                        </div>
                        <div *ngIf="event.eventTypeSelect == 'SensorValues'" style="cursor: pointer;">
                          <label *ngIf="i==0" for="{{'NumberSamples' + i}}" class="form-group" style="font-weight: 500;" >#Vals</label>
                          <input [(ngModel)]="sensorCondition.numberOfSamples" class="form-control" id="{{'NumberSamples' + i}}" name="{{'NumberSamples' + i}}" required type="number" style="height: 35px; padding-top: 0px;">
                        </div>
                      </td>

                      <td style="width:210px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'AnalysisDD' + i}}" style="font-weight: 500;">Analysis</label>
                          <ngx-select-dropdown name="{{'AnalysisDD' + i}}" [config]="NoSearchDDConfig" [options]="AnalysisTypeDDOptions" [(ngModel)]="sensorCondition.analysisType" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:120px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'ConditionDD' + i}}" style="font-weight: 500;">Comparator</label>
                          <ngx-select-dropdown name="{{'ConditionDD' + i}}" [config]="NoSearchDDConfig" [options]="ComparatorDDOptions" [(ngModel)]="sensorCondition.comparator" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:90px" align="left">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'Threshold' + i}}" style="font-weight: 500;">Threshold</label>
                          <input [(ngModel)]="sensorCondition.threshold" class="form-control" id="{{'Threshold' + i}}" name="{{'Threshold' + i}}" required type="text" style="height: 35px; padding-top: 0px;">
                        </div>
                      </td>

                      <td style="width:100px">
                        <div *ngIf="!lastel" class="form-group">
                          <label *ngIf="i==0" for="{{'LogicalDD' + i}}" style="font-weight: 500;">Combine</label>
                          <ngx-select-dropdown
                            name="{{'LogicalDD' + i}}" [config]="NoSearchDDConfig" [options]="LogicOperatorDDOptions" [(ngModel)]="sensorCondition.logicOperator" >
                          </ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:15px"></td>

                      <td style="width: 60px; color: #5279bc" class="modifications">
                        <label *ngIf="i==0" for="{{'AddSensorCondition' + i}}"><br></label>
                        <div *ngIf="!lastel" class="text-left">
                          <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delSensorCondition(i) "></div>
                        </div>
                        <div *ngIf="lastel" class="text-left">
                          <span class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delSensorCondition(i) "></span>
                          <span class="fas fa-plus pull-right" style="font-size: 18px; margin-top: 1px" aria-hidden="true " (click)="addSensorCondition()"></span>
                        </div>
                      </td>

                    </tr>

                    <tr *ngIf="event.sensorConditions.length==0">
                      <td style="width:30px; color: #5279bc" class="modifications">
                        <div class="fas fa-plus" aria-hidden="true " (click)="addSensorCondition()"></div>
                        <span class="sr-only">Plus</span>
                      </td>
                    </tr>

                  </table>
                </div>

                <div *ngIf="event.eventType=='Timer Based'">
                  <table style="width: 100%;">
                    <tr *ngFor="let timerCondition of event.timerConditions; let i = index; let firstel = first; let lastel = last ">
                      <td style="width:200px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'TimerTypeDD' + i}}" style="font-weight: 500;">Type</label>
                          <ngx-select-dropdown name="{{'TimerTypeDD' + i}}" [config]="NoSearchDDConfig" [options]="TimerTypeDDOptions" [(ngModel)]="timerCondition.type"></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:20px"></td>

                      <td style="width:250px">
                        <label *ngIf="i==0" for="{{'DaysOfWeek' + i}}" style="font-weight: 500; margin-bottom: 3px;">Days of Week</label>
                        <div class="weekDays-selector form-group" id="{{'DaysOfWeek' + i}}">
                          <input type="checkbox" id="{{'weekday-sun' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[0]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-sun' + i}}">S</label>
                          <input type="checkbox" id="{{'weekday-mon' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[1]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-mon' + i}}">M</label>
                          <input type="checkbox" id="{{'weekday-tue' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[2]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-tue' + i}}">T</label>
                          <input type="checkbox" id="{{'weekday-wed' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[3]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-wed' + i}}">W</label>
                          <input type="checkbox" id="{{'weekday-thu' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[4]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-thu' + i}}">T</label>
                          <input type="checkbox" id="{{'weekday-fri' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[5]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-fri' + i}}">F</label>
                          <input type="checkbox" id="{{'weekday-sat' + i}}" class="weekday" [(ngModel)]="timerCondition.daysOfWeek[6]" [ngModelOptions]="{standalone: true}" />
                          <label for="{{'weekday-sat' + i}}">S</label>
                        </div>
                      </td>

                      <td *ngIf="timerCondition.type=='Single'" style="width:250px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'TimingSingleDD' + i}}" style="font-weight: 500;">Timing</label>
                          <ngx-select-dropdown name="{{'TimingSingleDD' + i}}" [config]="NoSearchDDConfig" [options]="TimingSingleDDOptions" [(ngModel)]="timerCondition.timingSingle" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td *ngIf="timerCondition.type=='Repeat'" style="width:250px">
                        <div class="form-group">
                          <label *ngIf="i==0" for="{{'TimingRepeatDD' + i}}" style="font-weight: 500;">Timing</label>
                          <ngx-select-dropdown name="{{'TimingRepeatDD' + i}}" [config]="NoSearchDDConfig" [options]="TimingRepeatDDOptions" [(ngModel)]="timerCondition.timingRepeat" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:100px">
                        <div *ngIf="!lastel" class="form-group">
                          <label *ngIf="i==0" for="{{'TimerLogicalDD' + i}}" style="font-weight: 500;">Combine</label>
                          <ngx-select-dropdown name="{{'TimerLogicalDD' + i}}" [config]="NoSearchDDConfig" [options]="LogicOperatorDDOptions" [(ngModel)]="timerCondition.logicOperator" ></ngx-select-dropdown>
                        </div>
                      </td>

                      <td style="width:15px"></td>

                      <td style="width: 60px; color: #5279bc" class="modifications">
                        <label *ngIf="i==0" for="{{'AddDelTimerCondition' + i}}"><br></label>
                        <div *ngIf="!lastel" class="text-left">
                          <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="delTimerCondition(i) "></div>
                        </div>
                        <div *ngIf="lastel" class="text-left">
                          <span class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="delTimerCondition(i) "></span>
                          <span class="fas fa-plus pull-right" style="font-size: 18px; margin-top: 1px" aria-hidden="true" (click)="addTimerCondition()"></span>
                        </div>
                      </td>

                    </tr>

                    <tr *ngIf="event.timerConditions.length==0">
                      <td style="width:30px; color: #5279bc" class="modifications">
                        <div class="fas fa-plus" aria-hidden="true " (click)="addTimerCondition()"></div>
                        <span class="sr-only">Plus</span>
                      </td>
                    </tr>

                  </table>
                </div>

              </div>
            </div>
          </div>

          <br>

          <div class="card">
            <div style="background-color: #385723; color: white; font-size: 17px; padding-left: 10px; padding-top: 3px; height: 30px;">
              Event Actions
            </div>

            <div id="collapseAction" class="collapse show" aria-labelledby="ActionInfo" data-parent="#accordion">
              <div class="card-body">

                <!-- <div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 15px;">
                  <input type="radio" [(ngModel)]="event.useActionQueue" name="actionqueue" [value]="false" style="accent-color: #203864;" (ngModelChange)="onUseActionQueueChange(false)"/>
                  <label style="padding-left: 5px; padding-right: 5px; margin-right: 40px;">No Queue (Execute when triggered)</label>
                  <input type="radio" [(ngModel)]="event.useActionQueue" name="actionqueue" [value]="true" style="accent-color: #203864;" (ngModelChange)="onUseActionQueueChange(true)"/>
                  <label style="padding-left: 5px; padding-right: 5px;">Use Action Queue</label>
                  <div style="width: 400px;">
                    <ngx-select-dropdown name="QueueAction" id="QueueAction" [config]="actionQueueConfig" [options]="actionQueues" [(ngModel)]="selectedActionQueue" (change)="onActionQueueChange()"></ngx-select-dropdown>
                  </div>
                </div> -->

                <table style="width: 100%;">
                  <tr *ngFor="let action of event.eventActions; let i = index; let firstel = first; let lastel = last ">

                    <td style="width:190px">
                      <div class="form-group">
                        <label *ngIf="i==0" for="{{'ActionTypeDD' + i}}" style="font-weight: 500;">Type</label>
                        <ngx-select-dropdown name="{{'ActionTypeDD' + i}}" [config]="NoSearchDDConfig" [options]="ActionTypeDDOptions" [(ngModel)]="action.type"></ngx-select-dropdown>
                      </div>
                    </td>

                    <td *ngIf="action.type=='Email' || action.type=='Url'" style="width: 800px" align="left">
                      <div class="form-group">
                        <label *ngIf="i==0" for="{{'ActionDestination' + i}}" style="font-weight: 500;">Destination</label>
                        <input [(ngModel)]="action.destination" class="form-control" id="{{'ActionDestination' + i}}" name="{{'ActionDestination' + i}}" required type="text" style="height: 35px; padding-top: 0px;">
                      </div>
                    </td>

                    <td *ngIf="action.type=='Task'" style="width:800px" align="left">
                      <table style="width: 100%;">
                        <tr>
                          <td style="width:325px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'IrrigationDD' + i}}" style="font-weight: 500;">Gateway</label>
                              <ngx-select-dropdown name="{{'IrrigationDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrDestinationDDOptions" [(ngModel)]="action.deviceName" (change)="updateSelectedGateway(action)"></ngx-select-dropdown>
                            </div>
                          </td>

                          <div class="form-group" style="width:484px">
                            <label *ngIf="i==0" for="{{'TaskTarget' + i}}" style="font-weight: 500;">Task command and parameters</label>
                            <input [(ngModel)]="action.taskAction" class="form-control" id="{{'TaskTarget' + i}}" name="{{'TaskTarget' + i}}" required type="text" style="height: 35px; padding-top: 0px;" >
                          </div>
                        </tr>
                      </table>
                    </td>

                    <td *ngIf="action.type=='Camera'" style="width:800px" align="left">
                      <table style="width: 100%;">
                        <tr>
                          <td style="width:300px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'CamGatewayDD' + i}}" style="font-weight: 500;">Gateway</label>
                              <ngx-select-dropdown name="{{'CamGatewayDD' + i}}" [config]="NoSearchDDConfig" [options]="CamGatewayDDOptions" [(ngModel)]="action.deviceName" (change)="updateSelectedGateway(action)"></ngx-select-dropdown>
                            </div>
                          </td>
                          <td>
                            <div class="form-group" style="width:250px">
                              <label *ngIf="i==0" for="{{'CameraDD' + i}}" style="font-weight: 500;">Camera</label>
                              <ngx-select-dropdown name="{{'CameraDD' + i}}" [config]="NoSearchDDConfig" [options]="CameraDDOptions" [(ngModel)]="action.cameraName" (change)="updateSelectedCamera(action)" ></ngx-select-dropdown>
                            </div>
                          </td>
                          <div class="form-group" style="width:260px">
                            <label *ngIf="i==0" for="{{'CameraPresets' + i}}" style="font-weight: 500;">Cam Loc# (ex: 1 3 2 5). </label>
                            <input [(ngModel)]="action.cameraPresets" class="form-control" id="{{'CameraPresets' + i}}" name="{{'CameraPresets' + i}}" required type="text" style="height: 35px; padding-top: 0px;" [disabled]="!action.cameraModel.includes('Reolink')" >
                          </div>
                        </tr>
                      </table>
                    </td>

                    <td *ngIf="action.type=='Irrigation'" style="width:800px" align="left">
                      <table style="width: 100%;">
                        <tr>
                          <td style="width:325px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'IrrigationDD' + i}}" style="font-weight: 500;">Gateway</label>
                              <ngx-select-dropdown name="{{'IrrigationDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrDestinationDDOptions" [(ngModel)]="action.deviceName" (change)="updateSelectedGateway(action)"></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:125px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'ZoneDD' + i}}" style="font-weight: 500;">Zone</label>
                              <ngx-select-dropdown name="{{'ZoneDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrZoneDDOptions" [(ngModel)]="action.zone" ></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:250px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'ScheduleDD' + i}}" style="font-weight: 500;">Schedule</label>
                              <ngx-select-dropdown name="{{'ScheduleDD' + i}}" [config]="NoSearchDDConfig" [options]="globalWaterSchedules" [(ngModel)]="action.schedule" ></ngx-select-dropdown>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>

                    <td *ngIf="action.type=='FloodIrrigation'" style="width:800px" align="left">
                      <table style="width: 100%;">
                        <tr>
                          <td style="width:325px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'IrrigationDD' + i}}" style="font-weight: 500;">Gateway</label>
                              <ngx-select-dropdown name="{{'IrrigationDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrDestinationDDOptions" [(ngModel)]="action.deviceName" (change)="updateSelectedGateway(action)"></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:125px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'SourceZoneDD' + i}}" style="font-weight: 500;">Source Zone</label>
                              <ngx-select-dropdown name="{{'SourceZoneDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrZoneDDOptions" [(ngModel)]="action.sourceZone" ></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:125px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'FillZoneDD' + i}}" style="font-weight: 500;">Fill Zone</label>
                              <ngx-select-dropdown name="{{'FillZoneDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrZoneDDOptions" [(ngModel)]="action.fillZone" ></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:250px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'FillScheduleDD' + i}}" style="font-weight: 500;">Fill Schedule</label>
                              <ngx-select-dropdown name="{{'FillScheduleDD' + i}}" [config]="NoSearchDDConfig" [options]="globalWaterSchedules" [(ngModel)]="action.fillSchedule" ></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:125px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'DrainZoneDD' + i}}" style="font-weight: 500;">Drain Zone</label>
                              <ngx-select-dropdown name="{{'DrainZoneDD' + i}}" [config]="NoSearchDDConfig" [options]="IrrZoneDDOptions" [(ngModel)]="action.drainZone" ></ngx-select-dropdown>
                            </div>
                          </td>

                          <td style="width:250px">
                            <div class="form-group">
                              <label *ngIf="i==0" for="{{'DrainScheduleDD' + i}}" style="font-weight: 500;">Drain Schedule</label>
                              <ngx-select-dropdown name="{{'DrainScheduleDD' + i}}" [config]="NoSearchDDConfig" [options]="globalWaterSchedules" [(ngModel)]="action.drainSchedule" ></ngx-select-dropdown>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>

                    <td *ngIf="action.type=='AppMessage'" style="width:800px" align="left">
                      <div class="form-group">
                        <label *ngIf="i==0" for="{{'ActionDestination' + i}}" style="font-weight: 500;">Message</label>
                        <input [(ngModel)]="action.destination" class="form-control" id="{{'ActionDestination' + i}}" name="{{'ActionDestination' + i}}" required type="text" style="height: 35px; padding-top: 0px;" >
                      </div>
                    </td>

                    <td style="width:90px" align="left">
                      <div class="form-group">

                        <label *ngIf="i==0" for="{{'actionOptions' + i}}" style="font-weight: 500; margin-left: 5px; width: 80px;">Options</label>
                        <button *ngIf="action.type=='Camera'" id="{{'actionOptions' + i}}" name="{{'actionOptions' + i}}"
                                (click)="openMediaActionOptions(action, mediaActionOptionsTemplate)" class="btn btn-primary" style="height: 35px; padding-top: 3px; margin-left: 5px;" type="button">Options</button>
                        <button  *ngIf="action.type=='FloodIrrigation' || action.type=='Irrigation'" id="{{'actionOptions' + i}}" name="{{'actionOptions' + i}}"
                                (click)="openIrrigationActionOptions(action, irrigationActionOptionsTemplate)" class="btn btn-primary" style="height: 35px; padding-top: 3px; margin-left: 5px;" type="button">Options</button>
                        <button  *ngIf="(action.type=='Email' || action.type=='AppMessage') && event.eventType=='Sensor Based'" id="{{'actionOptions' + i}}" name="{{'actionOptions' + i}}"
                                (click)="openNotificationActionOptions(action, notificationActionOptionsTemplate)" class="btn btn-primary" style="height: 35px; padding-top: 3px; margin-left: 5px;" type="button">Options</button>
                      </div>
                    </td>

                    <td style="width:15px"></td>

                    <td style="width:30px" class="modifications">
                      <label *ngIf="i==0" for="{{'DeleteAction' + i}}"><br></label>
                      <div *ngIf="event.eventActions.length > 1" class="text-left">
                        <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="delEventAction(i) "></div>
                        <span class="sr-only ">Delete</span>
                      </div>
                    </td>

                    <td style="width:30px; color: #5279bc" class="modifications">
                      <label *ngIf="i==0" for="{{'AddActionPlus' + i}}"><br></label>
                      <div *ngIf="lastel" class="text-left">
                        <div class="fas fa-plus" style="font-size: 18px; margin-top: 1px" aria-hidden="true" (click)="addEventAction()"></div>
                        <span class="sr-only">Plus</span>
                      </div>
                    </td>

                  </tr>
                </table>

              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!embedded && event.userFeatureAccess['EditEvent']" style="margin-top: 15px;">
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
          <button class="btn btn-success col-xs-5 pull-right" type="submit">{{buttonValue}}</button>
          <button (click)="bsModalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 10px; margin-bottom: 15px;" type="button">Cancel</button> &nbsp;&nbsp;&nbsp;
        </div>

      </div>
    </div>
  </div>

</form>


<ng-template #mediaActionOptionsTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="actionOptions-modal">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
          <h5 style="color: rgb(10, 10, 10); text-transform: none;">Action Options</h5>
          <button
          (click)="actionOptionsRef.hide()"
          class="ms-auto fas fa-times"pe="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
          </button>
      </div>

      <div class="modal-body">

        <div *ngIf="eventAction.type == 'CaptureImage' || eventAction.type == 'CaptureVideo' || eventAction.type == 'PTZCaptureImage' || eventAction.type == 'Camera'" class="form-group" style="width: 500px;">
          <table style="width: 100%;">
            <tr *ngFor="let actionOption of eventAction.mediaActionOptions; let i = index; let firstel = first; let lastel = last " class="spaceUnder">

              <td>
                <div class="form-group" style="width:50px; margin-left: 10px;">
                  <label *ngIf="i==0" for="{{'PosId' + i}}" style="font-weight: 500; margin-bottom: 5px;">Loc Id</label>
                  <input [(ngModel)]="actionOption.PosId" id="{{'PosId' + i}}" name="{{'PosId' + i}}" disabled=true class="form-control" required type="text" style="height: 36px; text-align: center;"> 
                </div>
              </td>

              <td>
                <div class="form-group" style="width:430px; margin-left: 10px;">
                  <label *ngIf="i==0" for="{{'Tags' + i}}" style="font-weight: 500; margin-bottom: 5px;">Tags (separate tags with ',' commas)</label>
                  <input [(ngModel)]="actionOption.Tags" id="{{'Tags' + i}}" name="{{'Tags' + i}}" class="form-control" required type="text" style="height: 36px" (ngModelChange)="common.removeReservedCharsInActionOptions(actionOption)">
                </div>
              </td>

              <td>
                <div class="form-group" style="width:60px; margin-left: 10px; text-align: center;">
                  <label *ngIf="i==0" for="{{'ExpireDays' + i}}" style="font-weight: 500; margin-bottom: 5px;">Expire Days</label>
                  <input [(ngModel)]="actionOption.ExpireDays" id="{{'ExpireDays' + i}}" name="{{'ExpireDays' + i}}" class="form-control" required type="text" style="height: 36px; text-align: center;">
                </div>
              </td>

              <td>
                <div class="form-group" style="width:60px; margin-left: 10px; text-align: center;">
                  <label *ngIf="i==0" for="{{'SleepAfter' + i}}" style="font-weight: 500; margin-bottom: 5px;">Sleep (sec)</label>
                  <input [(ngModel)]="actionOption.SleepAfter" id="{{'SleepAfter' + i}}" name="{{'SleepAfter' + i}}" class="form-control" required type="text" style="height: 36px; text-align: center;">
                </div>
              </td>
              
              <td>
                <div class="form-group" style="width:100px; margin-left: 10px; text-align: center;">
                  <label *ngIf="i==0" for="{{'CameraMode' + i}}" style="font-weight: 500; margin-bottom: 5px;">Camera Mode</label>
                  <!-- <input [(ngModel)]="actionOption.CameraMode" id="{{'CameraMode' + i}}" name="{{'CameraMode' + i}}" class="form-control" required type="text" style="height: 35px; text-align: center;"> -->
                  <ngx-select-dropdown name="{{'CameraModeDD' + i}}" [config]="NoSearchDDConfig" [options]="CameraModeDDOptions" [(ngModel)]="actionOption.CameraMode" ></ngx-select-dropdown>
                </div>
              </td>

              <td>
                <div class="form-group" style="width:70px; margin-left: 10px; text-align: center;">
                  <label *ngIf="i==0" for="{{'VideoDuration' + i}}" style="font-weight: 500; margin-bottom: 5px;">Duration (sec)</label>
                  <input [(ngModel)]="actionOption.VideoDuration" id="{{'VideoDuration' + i}}" name="{{'VideoDuration' + i}}" [disabled]="actionOption.CameraMode == 'image'" class="form-control" required type="text" style="height: 36px; text-align: center;">
                </div>
              </td>
            </tr>
          </table>

          <div class="form-group" style="width: 500px; margin-top: 15px; margin-left: 10px; margin-bottom: 15px;">
            <label style="font-weight: 500;">On action error, send email to:</label>
            <input [(ngModel)]="eventAction.onError" class="form-control" required type="text" style="height: 35px">
          </div>

        </div>
      </div>
  </div>
</ng-template>


<ng-template #irrigationActionOptionsTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="actionOptions-modal">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
          <h5 style="color: rgb(10, 10, 10); text-transform: none;">Action Options</h5>
          <button
          (click)="actionOptionsRef.hide()"
          class="ms-auto fas fa-times"pe="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
          </button>
      </div>

      <div class="modal-body">
        <!-- <div style="margin-left: 10px; margin-top: 15px; margin-bottom: 20px; display: flex; align-items: flex-start;">
          <input type="checkbox" id="QueueAction" [(ngModel)]="eventAction.irrigationActionOptions.UseQueue" [ngModelOptions]="{standalone: true}" style="margin-right: 15px; margin-top: 6px;"/>
          <div class="form-group" style="width: 50%;">
              <label for="QueueAction">When triggered, add this action to the following queue</label>
              <ngx-select-dropdown name="QueueAction" id="QueueAction" [config]="actionQueueConfig" [options]="actionQueues" [(ngModel)]="selectedActionQueue" (change)="onActionQueueChange($event)"></ngx-select-dropdown>
          </div>
        </div> -->

        <div class="form-group" style="width: 500px; margin-left: 10px; margin-bottom: 25px;">
          <label>On action error, send email to:</label>
          <input [(ngModel)]="eventAction.onError" class="form-control" required type="text" style="height: 35px">
        </div>
        <button (click)="resetTriggerButtonStatus(eventAction)" class="btn btn-primary btn-sm" style="height: 35px; margin-left: 10px; margin-bottom: 10px;" type="button">Reset Trigger Status</button>

      </div>
  </div>
</ng-template>


<ng-template #notificationActionOptionsTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="actionOptions-modal">
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
          <h5 style="color: rgb(10, 10, 10); text-transform: none;">Action Options</h5>
          <button
          (click)="actionOptionsRef.hide()"
          class="ms-auto fas fa-times"pe="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
          </button>
      </div>

      <div class="modal-body">

        <div class="form-group" style="width: 500px; margin-left: 10px; margin-bottom: 25px;">
          <label style="font-weight: 500;">Include these sections in the {{ (eventAction.type == 'Email') ? 'email' : 'message' }} and the activity log:</label>

          <div style="margin-top: 10px;">
            <input type="checkbox" id="includeReadingsMeetingCondition" name="includeReadingsMeetingCondition"
                   [(ngModel)]="eventAction.notificationSectionOptions.IncludeMatchedReadings" [ngModelOptions]="{standalone: true}" style="cursor: pointer;"/>
            <label for="includeReadingsMeetingCondition" style="padding-left: 8px; font-weight: normal; cursor: pointer;">Readings Meeting Condition</label>
          </div>

          <div style="margin-top: 8px;">
            <input type="checkbox" id="includeAllReadingsEvaluated" name="includeAllReadingsEvaluated"
                   [(ngModel)]="eventAction.notificationSectionOptions.IncludeAllReadings" [ngModelOptions]="{standalone: true}" style="cursor: pointer;"/>
            <label for="includeAllReadingsEvaluated" style="padding-left: 8px; font-weight: normal; cursor: pointer;">All Readings Evaluated</label>
          </div>

          <div style="margin-top: 12px; font-size: 12px; font-style: italic;">
            With neither section selected, only the summary lines are included.
          </div>
        </div>

        <div class="form-group" style="width: 500px; margin-left: 10px; margin-bottom: 15px;">
          <label style="font-weight: 500;">On action error, send email to:</label>
          <input [(ngModel)]="eventAction.onError" class="form-control" required type="text" style="height: 35px">
        </div>

      </div>
  </div>
</ng-template>